import React, { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { getBattlebotSlotCenterPixels } from '../components/BattlebotPortalOverlay';
import './VeinSeverSlashEffect.css';

/**
 * Glowing red slashing strokes on the Vein Sever target unit slot.
 * Prefer `centerPoint` when supplied (same coords as strategem damage); otherwise measures `viewerSlot`.
 */
export function VeinSeverSlashEffect({ viewerSlot, animationKey, centerPoint }) {
  const [center, setCenter] = useState(null);

  useLayoutEffect(() => {
    if (
      centerPoint &&
      Number.isFinite(centerPoint.x) &&
      Number.isFinite(centerPoint.y)
    ) {
      setCenter({ x: centerPoint.x, y: centerPoint.y });
      return undefined;
    }

    let cancelled = false;
    const measure = (attempt) => {
      if (!viewerSlot?.zone || viewerSlot.index == null) {
        if (!cancelled) setCenter(null);
        return;
      }
      const pt = getBattlebotSlotCenterPixels(viewerSlot.zone, viewerSlot.index);
      if (pt) {
        if (!cancelled) setCenter(pt);
        return;
      }
      if (attempt < 22 && !cancelled) {
        requestAnimationFrame(() => {
          if (!cancelled) measure(attempt + 1);
        });
      }
    };
    setCenter(null);
    measure(0);
    return () => {
      cancelled = true;
    };
  }, [viewerSlot, animationKey, centerPoint]);

  if (!center) {
    return null;
  }

  const layer = (
    <div
      className="vein-sever-slash-root"
      aria-hidden
      data-animation-key={animationKey}
      style={{
        left: `${center.x}px`,
        top: `${center.y}px`,
        transform: 'translate(-50%, -50%)',
      }}
    >
      <div className="vein-sever-slash-blades">
        <span className="vein-sever-slash-blade vein-sever-slash-blade--a" />
        <span className="vein-sever-slash-blade vein-sever-slash-blade--b" />
        <span className="vein-sever-slash-blade vein-sever-slash-blade--c" />
      </div>
    </div>
  );

  if (typeof document !== 'undefined' && document.body) {
    return createPortal(layer, document.body);
  }
  return layer;
}

export default VeinSeverSlashEffect;
